import { memo } from "react";

import { ProductSelectorPlaceholder } from "@react/sections/ProductHero/ProductSelector/ProductSelectorPlaceholder.view";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";

import { ProductSelectorView } from "./ProductSelector.view";
import {
  type ProductSelectorSettings,
  useProductSelector,
} from "./ProductSelectorContext";

const ProductSelectorBase = () => {
  const {
    isLoading,
    label,
    productComboOptionIds,
    selectedIndex,
    selectedProductComboOption,
    selectedVariantsByIndex,
  } = useProductSelector();
  const {
    meta: {
      localization: { country },
    },
    settings: { intelligemsEnabled, klarnaEnabled, theme },
  } = useSectionSettings<ProductSelectorSettings>();

  if (isLoading) {
    return <ProductSelectorPlaceholder />;
  }

  return (
    <ProductSelectorView
      country={country}
      isIntelligemsEnabled={intelligemsEnabled}
      isKlarnaEnabled={klarnaEnabled}
      label={label}
      productComboOptionIds={productComboOptionIds}
      selectedIndex={selectedIndex}
      selectedProductComboOption={selectedProductComboOption}
      selectedVariantsByIndex={selectedVariantsByIndex}
      theme={theme}
    />
  );
};

export const ProductSelector = memo(ProductSelectorBase);
